const strings = {
  en: {
    sectionLabel: 'Legal',
    title: 'Copyright Notice',
    subtitle: 'Copyright, trademark, brand, and website content usage terms for SAPOT AI.',
    s1Title: '1. Ownership',
    s1p1: 'Unless otherwise stated, this website and its contents are owned by Dataverse Sdn Bhd and/or its licensors. This includes text, graphics, branding, logos, interface elements, layouts, product descriptions, videos, images, software-related materials, and other original content made available on SAPOT AI channels.',
    s2Title: '2. Copyright Protection',
    s2p1: 'All content on this website is protected by applicable copyright and intellectual property laws. No part of this website may be copied, reproduced, republished, uploaded, posted, publicly displayed, translated, distributed, or adapted without prior written permission, except where limited use is permitted by law.',
    s3Title: '3. Permitted Use',
    s3p1: 'You may access and use this website for your own lawful business or informational purposes.',
    s3l1: [
      'You may view, download, or print limited portions for internal reference only.',
      'You may not modify or remove copyright, trademark, or proprietary notices.',
      'You may not use our content in a misleading, competitive, or commercial resale context.',
    ],
    s4Title: '4. Trademarks',
    s4p1: 'SAPOT AI, SAPOT Note, related logos, and associated brand elements are trademarks or trade dress of Dataverse Sdn Bhd unless otherwise indicated. Unauthorized use of these marks is prohibited.',
    s5Title: '5. Third-Party Materials',
    s5p1: 'Some materials shown on this website may contain third-party names, trademarks, images, media, or links. Those rights remain the property of their respective owners. Their appearance does not imply ownership by SAPOT AI unless explicitly stated.',
    s6Title: '6. Requests for Reuse',
    s6p1: 'If you would like to reuse, quote, republish, or license any content from this website, please contact us first for written approval. Include the specific material, intended usage, distribution channel, and timing in your request.',
    s7Title: '7. Reporting Infringement',
    s7p1: 'If you believe your copyrighted material has been used on this website in a way that infringes your rights, contact us with sufficient detail so we can review the matter promptly.',
    s7l1: [
      'Your full name and contact information',
      'A description of the copyrighted work',
      'The page or material you believe is infringing',
      'A statement supporting your claim of ownership or authorization',
    ],
    s8Title: '8. Contact',
    s8p1: 'For copyright, licensing, or intellectual property matters, please contact us at:',
  },
  zh: {
    sectionLabel: '法律',
    title: '版权声明',
    subtitle: 'SAPOT AI 的版权、商标、品牌及网站内容使用条款。',
    s1Title: '1. 所有权',
    s1p1: '除另有说明外，本网站及其内容归 Dataverse Sdn Bhd 及/或其许可方所有，包括文字、图形、品牌标识、标志、界面元素、排版、产品说明、视频、图像、软件相关资料以及在 SAPOT AI 各渠道发布的其他原创内容。',
    s2Title: '2. 版权保护',
    s2p1: '本网站的所有内容均受适用的版权与知识产权法律保护。未经事先书面许可，禁止以任何形式复制、转载、重新发布、上传、发布、公开展示、翻译、分发或改编本网站的任何部分，法律另有允许的有限使用情形除外。',
    s3Title: '3. 允许的使用',
    s3p1: '您可在合法的业务或信息用途范围内访问和使用本网站。',
    s3l1: [
      '您可以出于内部参考目的查看、下载或打印有限的内容。',
      '您不得修改或移除任何版权、商标或专有权利声明。',
      '您不得在具有误导性、竞争性或商业转售性质的场景中使用我们的内容。',
    ],
    s4Title: '4. 商标',
    s4p1: '除另有说明外，SAPOT AI、SAPOT Note、相关标志及关联品牌元素均为 Dataverse Sdn Bhd 的商标或商业外观。未经授权禁止使用上述标识。',
    s5Title: '5. 第三方素材',
    s5p1: '本网站中展示的部分素材可能包含第三方名称、商标、图像、媒体或链接。相关权利仍归其各自所有者所有。除非另有明确说明，否则其出现并不表示 SAPOT AI 拥有这些权利。',
    s6Title: '6. 再次使用申请',
    s6p1: '如您希望再次使用、引用、转载或许可本网站的任何内容，请先联系我们以获取书面授权。请在申请中注明具体素材、预期用途、发布渠道及时间安排。',
    s7Title: '7. 侵权举报',
    s7p1: '若您认为本网站使用您的受版权保护素材的方式侵犯了您的权利，请向我们提供充分的信息，以便我们及时审查相关事项。',
    s7l1: [
      '您的全名与联系方式',
      '受版权保护作品的描述',
      '您认为存在侵权的页面或素材',
      '能够支持您主张权利或获得授权的声明',
    ],
    s8Title: '8. 联系方式',
    s8p1: '如有任何版权、许可或知识产权相关事宜，请通过以下方式联系我们：',
  },
};

export default strings;
